module.exports = __webpack_public_path__ + "img/repairTwo.8c635564.png";